import { log } from '@lib/logger';

export const reportWebVitals = (metrics: FIXME) => {
  log.info(metrics);
};
